// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1_cbt","empty":"ModalGraph_empty__1YtDo"};